import { useToast } from "../hooks/useToast";
import { getPublicIP, enqueueLog, flushQueue } from "../utils/logsHelper";

export function useApi() {
  const { presentToast } = useToast();
  const outletCode = localStorage.getItem("outlet-code") || "-";

  const apiFetch = async (url: string, options: RequestInit = {}) => {
    const token = localStorage.getItem("authKey") ?? "";
    const ip = await getPublicIP();

    try {
      const res = await fetch(url, {
        ...options,
        headers: {
          ...options.headers,
          "Content-Type": "application/json",
          "X-Auth-Key": token,
        },
      });

      if (res.status === 401 || res.status === 403) {
        localStorage.clear();
        presentToast({ message: "Sesi kamu sudah habis, silakan login ulang", color: "danger" });
        window.location.href = "/";
        throw new Error("Unauthorized");
      }

      if (!res.ok) {
        const bodyText = await res.text();

        await enqueueLog({
          url,
          subject: "API_FETCH_ERROR",
          outlet_code: outletCode,
          request: JSON.stringify(options.body || {}),
          response_status: res.status,
          response: bodyText,
          ip,
          user_agent: navigator.userAgent,
        });

        throw new Error(`HTTP ${res.status}: ${bodyText}`);
      }

      flushQueue().catch(console.warn);

      return res.json();
    } catch (error: any) {
      console.error("API fetch error:", error);

      await enqueueLog({
        url,
        subject: "FETCH_EXCEPTION",
        outlet_code: outletCode,
        request: JSON.stringify(options.body || {}),
        response_status: "FETCH_ERROR",
        response: error.message,
        ip,
        user_agent: navigator.userAgent,
      });

      throw error;
    }
  };

  return { apiFetch };
}
